// removed by extract-text-webpack-plugin
module.exports = {"body":"_3JxI"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Modal/ConfirmModal/ConfirmModal.scss
// module id = PtQi
// module chunks = 0